import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import './wompi-checkout.css'

type Copy = Record<string, string>

export function WhopResultPage() {
  const [params] = useSearchParams()
  const orderId = params.get('order_id') || ''
  const lang = params.get('lang') || 'es'
  const whopStatus = (params.get('status') || '').toLowerCase()
  const [status, setStatus] = useState(whopStatus === 'failed' || whopStatus === 'canceled' ? 'failed' : 'pending')
  const [copy, setCopy] = useState<Copy>({})

  useEffect(() => {
    if (!orderId || status === 'failed') return
    let stop = false
    let tries = 0
    const tick = async () => {
      try {
        const res = await fetch(`/api/whop/checkout/${encodeURIComponent(orderId)}?lang=${encodeURIComponent(lang)}`)
        const body = await res.json()
        if (stop) return
        if (body.copy) setCopy(body.copy)
        const next = String(body.payment_status || 'pending')
        setStatus(next)
        if (next === 'pending' && tries < 12) {
          tries += 1
          window.setTimeout(tick, 2000)
        }
      } catch {
        if (!stop && tries < 12) {
          tries += 1
          window.setTimeout(tick, 2000)
        }
      }
    }
    tick()
    return () => { stop = true }
  }, [orderId, lang, status])

  const failed = status === 'failed' || status === 'expired' || status === 'refunded' || status === 'partially_paid'
  const title = status === 'finished'
    ? (copy.result_ok_title || 'Pago aprobado')
    : failed
      ? (copy.result_fail_title || 'Pago no completado')
      : (copy.result_pending_title || 'Pago en proceso')
  const body = status === 'finished'
    ? (copy.result_ok_body || '')
    : failed
      ? (copy.result_fail_body || '')
      : (copy.result_pending_body || '')

  return (
    <div className="wompi-shell">
      <div className="wompi-wrap">
        <div className="wompi-brand"><span className="wompi-dot" /><b>Whop</b></div>
        <div className="wompi-card wompi-result">
          <h1>{title}</h1>
          <p>{body}</p>
          {orderId && <p className="wompi-order">{copy.order || 'Orden'} {orderId}</p>}
          <p className="wompi-secure">{copy.close_hint}</p>
        </div>
      </div>
    </div>
  )
}
